import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';
import type {GetRefundProcedureTherapies} from 'domain/usecases/private/refund/request/get-procedure-therapies';
import {RemoteRefundGetProcedureTherapies} from 'data/usecases/private/refund/request/remote-get-procedure-therapies';

export const makeGetRefundProcedureTherapies = (): GetRefundProcedureTherapies =>
	new RemoteRefundGetProcedureTherapies(
		makeBFFApiUrl(RefundFlowEndPoints.procedureTherapies),
		makeAuthorizeHttpClientDecorator(),
	);
